import { ref, type UnwrapRef } from 'vue'
import { defineStore } from 'pinia'
import type { Dish } from '~/interfaces/dishes'

export const useDishesStore = defineStore('dishes', () => {
  const dishes:Ref<UnwrapRef<Dish[]>> = ref([])

    const add = (dish: Dish) => {
      var index = dishes.value.findIndex(el => el.id == dish.id)
        if (index == -1) {
          dishes.value.push(dish)
        } else {
          dishes.value[index] = dish
        }
    }
    const getAll = () => {
      return dishes
    }

  return { add, getAll }
})
